import { DefaultError, useQuery } from "@tanstack/react-query";
import {
  CustomValuesByTypeResponse,
  fetchCustomValue,
  fetchCustomValuesByType
} from "PFCore/services/admin/custom_values";
import { _CustomValue, Id, QueryOptions } from "PFTypes";
import { QueryParams } from "PFTypes/query_params";

import { customValueKeys } from "./query_keys";

export type UseCustomValuesByTypeParams<TData = CustomValuesByTypeResponse> = {
  customTypeId: Id;
  params: QueryParams;
  options?: QueryOptions<CustomValuesByTypeResponse, DefaultError, TData>;
};

export const useCustomValuesByType = <TData = CustomValuesByTypeResponse>({
  customTypeId,
  params,
  options
}: UseCustomValuesByTypeParams<TData>) =>
  useQuery<CustomValuesByTypeResponse, DefaultError, TData>({
    queryKey: customValueKeys.list(customTypeId, params),
    queryFn: () => fetchCustomValuesByType(customTypeId, params),
    retry: false,
    ...options
  });

export const useCustomValue = (customTypeId: Id, customValueId: Id, options?: QueryOptions<_CustomValue>) =>
  useQuery<_CustomValue>({
    queryKey: customValueKeys.single(customTypeId, customValueId),
    queryFn: () => fetchCustomValue(customTypeId, customValueId),
    ...options
  });
